























































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import Sortable from 'sortablejs';
import store from '@/store';
import { mapState, mapGetters } from 'vuex';
import { ViewpointDao } from "@/api/ViewpointDao";
import ViewpointSelector from '@/components/common/viewpoint-selector.vue';
import ConfirmationDialog from '@/components/common/confirmation-dialog.vue';

let apiDao: ViewpointDao = new ViewpointDao();

export default Vue.extend({

  name: 'FavoriteViewer',

  components: {
    ViewpointSelector,
    ConfirmationDialog,
  },

  props: {
    sourceViewpointsProp: {
      type: Array,
      default: () => ([]),
    },
    sourceViewpointIdProp: {
      type: String,
      default: '',
    },
    compareProp: {
      type: Boolean,
      default: false,
    },
    targetViewpointsProp: {
      type: Array,
      default: () => ([]),
    },
    targetViewpointIdProp: {
      type: String,
      default: '',
    },
    teamProp: {
      type: Object,
      default: () => ({}),
    },
    authorizedActionsProp: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      packageId: this.$store.getters.getPackageId,
      compare: this.compareProp,
      sourceApiResponse: {} as any,
      sourceViewpoints: this.sourceViewpointsProp,
      sourceViewpointId: this.sourceViewpointIdProp,
      sourceError: '',
      sourceItem: {} as any,
      sourceDialog: false,
      sourceDialogRemember: false,
      sourceLoading: false,
      targetApiResponse: {} as any,
      targetViewpoints: this.targetViewpointsProp,
      targetViewpointId: this.targetViewpointIdProp,
      targetError: '',
      targetItem: {} as any,
      targetDialog: false,
      targetDialogRemember: false,
      targetLoading: false,
      sourceTargetDiff: {
                          copyItems:   [],
                          sameItems:   [],
                          deleteItems: [],
                        } as any,
      viewerCols: 12,
      sourcePage: 1,
      sourceItemsPerPage: -1,
      targetPage: 1,
      targetItemsPerPage: -1,
      headers:  [
                  { text: "User Rank", value: "userRank", sortable: true, width: '108px', align: 'center', },
                //  { text: "Score", value: "score", sortable: true, width: '108px', align: 'center', },
                //  { text: "Photo", value: "choiceFactors.F17.value", sortable: false, width: '80px', align: 'center', },
                  { text: "Price", value: "choiceFactors.F15.value", sortable: true, width: '88px', align: 'left', },
                  { text: "Score", value: "score", sortable: true, width: '64px', align: 'center', },
                //  { text: "Rank", value: "userRank", sortable: true, width: '48px', align: 'right', },
                  { text: 'Actions', value: 'actions', sortable: false, width: '60px', align: 'center', },
                ],
      hideHeader: true,
      hideFooter: true,
      thumbWidth: 100,
      thumbHeight: 75,
    };
  },

  created() {
    console.log('[ FavoriteViewer created() ]');
    if (this.sourceViewpointId) {
      this.loadFavorites(this.sourceViewpointId, 'source');
    }
    if (this.targetViewpointId) {
      this.loadFavorites(this.targetViewpointId, 'target');
    }
    if (this.compare) {
      this.viewerCols = 6;
    }
  },

  mounted() {
  },

  watch: {
    sourceViewpointIdProp(newVal, oldVal) {
      this.sourceViewpointId = newVal;
    },
    sourceViewpointId(newVal, oldVal) {
      if (newVal) {
        this.loadFavorites(newVal, 'source');
      } else {
        this.sourceApiResponse = {};
      }
    },
    targetViewpointIdProp(newVal, oldVal) {
      this.targetViewpointId = newVal;
    },
    targetViewpointId(newVal, oldVal) {
      if (newVal) {
        this.loadFavorites(newVal, 'target');
      } else {
        this.targetApiResponse = {};
      }
    },
    compareProp(newVal, oldVal) {
      this.compare = newVal;
      this.viewerCols = ( newVal ? 6 : 12 )
    },
    sourceItems(newVal, oldVal) {
      this.setSourceTargetDiff();
    },
    targetItems(newVal, oldVal) {
      this.setSourceTargetDiff();
    },
  },

  computed: {

     ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),

    loading(): boolean {
      return (this.sourceLoading || this.targetLoading);
    },

    sourceItems(): any[] {
      if (this.sourceApiResponse.hasOwnProperty('choices')) {
        const res: any[] = _.sortBy(_.map(this.sourceApiResponse.choices), [ (choice: any) => ( choice.userRank) ]);
        return res;
      } else {
        return [];
      }
    },

    targetItems(): any[] {
      if (this.targetApiResponse.hasOwnProperty('choices')) {
        const res: any[] = _.sortBy(_.map(this.targetApiResponse.choices), [ (choice: any) => ( choice.userRank) ]);
        return res;
      } else {
        return [];
      }
    },

    filteredHeaders(): any[] {
      if (this.compare) {
        return this.headers;
      } else {
        return this.headers.filter( (header: any) => (header.value !== "actions") );
      }
    },

  },

  methods: {



    createDraggableElements() {
      var el: any = document.getElementById(this.sourceViewpointId);
      var tableBody: any = el.getElementsByTagName('tbody')[0];
      // let table = document.querySelector(".v-data-table tbody");
      const _self = this;
      var newIndex: any = null;
      var oldIndex: any = null;
      Sortable.create(tableBody, {
        // handle: '.handle', // Use handle so user can select text
        onEnd(evt: any) {
          const rowSelected = _self.sourceItems.splice(evt.oldIndex, 1)[0]; // Get the selected row and remove it
          _self.sourceItems.splice(evt.newIndex, 0, rowSelected); // Move it to the new index
        }
      });
    },

    async loadFavorites(viewpointId: string, location: string) {
      if (location == 'source') { this.sourceLoading = true; }
      if (location == 'target') { this.targetLoading = true; }
      let queryParameters: any = {};
      let res: any = {};
      let err: any = '';
      await apiDao.getFavorites(this.packageId, viewpointId, queryParameters)
        .then( response => {
          console.log('[ loadFavorites() > apiDao.getFavorites > RESPONSE ]: ' + location);
          console.log(response);
          res = response;
        })
        .catch( error => {
          console.log('[ loadFavorites() > apiDao.getFavorites > ERROR ]: ' + location);
          console.log(error);
          err = error;
        });
      if ( Object.keys(res).length ) {
        switch(location) {
          case 'source':
            this.loadScoredChoices(viewpointId, location, res);
            break;
          case 'target':
            this.loadScoredChoices(viewpointId, location, res);
            break;
        }
      } else {
        switch(location) {
          case 'source':
            this.sourceApiResponse = {};
            this.sourceError = err;
            this.sourceLoading = false;
            break;
          case 'target':
            this.targetApiResponse = {};
            this.targetError = err;
            this.targetLoading = false;
            break;
        }
      }
    },

    async loadScoredChoices(viewpointId: string, location: string, loadFavoritesRes: any) {
      const choiceIds = _.map(loadFavoritesRes,'id');
      if (choiceIds.length) {
        const queryParameters: any = {
          choiceId: choiceIds
        };
      let res: any = {};
      let err: any = '';
      await apiDao.getScoredChoices(this.packageId, viewpointId, queryParameters)
        .then( response => {
          console.log('[ loadScoredChoices() > apiDao.getScoredChoices > RESPONSE ]: ' + location);
          console.log(response);
          res = response;
        })
        .catch( error => {
          console.log('[ loadScoredChoices() > apiDao.getScoredChoices > ERROR ]: ' + location);
          console.log(error);
          err = error;
        });
        if ( res.hasOwnProperty('choices') ) {
          switch(location) {
            case 'source':
              Object.keys(res.choices).forEach( (choice: any) => {
                const choiceId: any = res.choices[choice].id;
                const userRank: any = loadFavoritesRes[choiceId].rank;
                res.choices[choice].userRank = userRank;
              });
              this.sourceApiResponse = res;
              this.sourceError = err;
              break;
            case 'target':
              Object.keys(res.choices).forEach( (choice: any) => {
                const choiceId: any = res.choices[choice].id;
                const userRank: any = loadFavoritesRes[choiceId].rank;
                res.choices[choice].userRank = userRank;
              });
              this.targetApiResponse = res;
              this.targetError = err;
              break;
          }
        } else {
          switch(location) {
            case 'source':
              console.log('EMPTY CHOICES - loadScoredChoices(): ' + location);
              this.sourceApiResponse = {};
              this.sourceError = err;
              break;
            case 'target':
              console.log('EMPTY CHOICES - loadScoredChoices(): ' + location);
              this.targetApiResponse = {};
              this.targetError = err;
              break;
          }
        }
      }
      if (location == 'source') { this.sourceLoading = false; }
      if (location == 'target') { this.targetLoading = false; }
    },

    copyItemDialog(item: any) {
      this.sourceItem = item;
      this.sourceDialog = true;
      this.targetDialog = false;
    },

    async copyItem() {
      this.sourceDialog = false;
      // this.targetLoading = true;
      console.log('[ COPY ITEM ]');
      await apiDao.addFavoriteToViewpoint(this.packageId, this.targetViewpointId, this.sourceItem.id)
        .then( response => {
          console.log('[ copyItem() > apiDao.addFavoriteToViewpoint > RESPONSE ]');
          console.log(response);
        })
        .catch( error => {
          console.log('[ copyItem() > apiDao.addFavoriteToViewpoint > ERROR ]');
          console.log(error);
        });
      // this.targetLoading = false;
      // this.loadFavorites(this.sourceViewpointId, 'source');
      this.loadFavorites(this.targetViewpointId, 'target');
    },

    deleteItemDialog(item: any) {
      this.targetItem = item;
      this.targetDialog = true;
      this.sourceDialog = false;
    },

    async deleteItem() {
      this.targetDialog = false;
      // this.targetLoading = true;
      console.log('[ DELETE ITEM ]');
      await apiDao.removeFavoriteFromViewpoint(this.packageId, this.targetViewpointId, this.targetItem.id)
        .then( response => {
          console.log('[ deleteItem() > apiDao.removeFavoriteFromViewpoint > RESPONSE ]');
          console.log(response);
        })
        .catch( error => {
          console.log('[ deleteItem() > apiDao.removeFavoriteFromViewpoint > ERROR ]');
          console.log(error);
        })
        .finally( () => {
          console.log('[ deleteItem() > apiDao.removeFavoriteFromViewpoint > FINALLY ]');
        });
      // this.targetLoading = false;
      // this.loadFavorites(this.sourceViewpointId, 'source');
      this.loadFavorites(this.targetViewpointId, 'target');
    },

    setSourceTargetDiff() {
      if (this.sourceItems.length && this.targetItems.length) {
        const sourceItems: any[] = _.map(this.sourceItems, 'id');
        const targetItems: any[] = _.map(this.targetItems, 'id');
        this.sourceTargetDiff.copyItems   = sourceItems.filter( (item: any) => !targetItems.includes(item) );
        this.sourceTargetDiff.sameItems   = sourceItems.filter( (item: any) =>  targetItems.includes(item) );
        this.sourceTargetDiff.deleteItems = targetItems.filter( (item: any) => !sourceItems.includes(item) );
      } else {
        this.sourceTargetDiff.copyItems.length = 0;
        this.sourceTargetDiff.sameItems.length = 0;
        this.sourceTargetDiff.deleteItems.length = 0;
      }
    },

    isAuthorized(action: string): boolean {
      return this.authorizedActionsProp.includes(action);
    },

    formatPrice(price: any): any {
      const res: any = Number(price).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      return res;
    },

    formatScore(score: number, decimals: number = 1): number {
      // const res: any = Number(Math.round(Number(score+'e'+decimals))+'e-'+decimals)*10;
      const res: any = Math.round(Number(score)*100) / 10;
      return res.toFixed(decimals);
    },

    sourceViewpointSelected(viewpointId: any) {
      console.log('[ viewpointSelected() > sourceViewpointId ]' + viewpointId);
      this.sourceViewpointId = viewpointId;
    },

    targetViewpointSelected(viewpointId: any) {
      console.log('[ viewpointSelected() > targetViewpointId ]' + viewpointId);
      this.targetViewpointId = viewpointId;
    },

    formatNumber(value: number, digits: number = 0) {
      if (digits < 0) digits = 0;
      var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      });
      return Number(formatter.format(value));
    },

  },


});

